<template>
    <div>
        <div class="card">
            <div class="card-header">反馈问卷管理</div>
            <div class="card-body" v-if="surveyPaperData.length === 0">
                <div class="alert alert-warning mb-0">没有反馈问卷信息<template v-if="canEdit">，请添加</template></div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 5%">序号</th>
                    <th class="text-center align-middle" style="width: 20%">名称</th>
                    <th class="text-center align-middle" style="width: 20%">问卷模板</th>
                    <th class="text-center align-middle" style="width: 27%">讲师课程</th>
                    <th class="text-center align-middle" style="width: 8%">评价结果</th>
                    <th class="text-center align-middle" style="width: 9%">状态</th>
                    <th class="text-center align-middle" style="width: 10%">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(paper, index) in surveyPaperData">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{paper.surveyPaperName}}</td>
                    <td class="text-left align-middle">{{paper.surveyTemplateName}}</td>
                    <td class="text-left align-middle">
                        <template v-if="paper.surveyTemplateType===surveyTemplateType.V2_FOR_COURSE_TEACHER">
                            <ul class="mb-0">
                                <li v-for="(teacherCourse, index) in paper.teacherCourseData">
                                    {{teacherCourse.personName}} - {{teacherCourse.courseName}}
                                    <a href="#" class="ml-2" v-if="paper.state === surveyPaperState.NON_PUBLISHED"
                                       @click.prevent="btnDeleteTeacherCourseData_Click(teacherCourse.surveyPaperTeacherCourseId)">删除</a>
                                </li>
                            </ul>
                            <button class="btn btn-primary btn-sm" :class="{'mt-2': paper.teacherCourseData.length !== 0}"
                                    v-if="paper.state === surveyPaperState.NON_PUBLISHED"
                                    @click="btnAddPaperTeacherCourseInfo_Click(paper.surveyPaperId)">添加关联的讲师与课程</button>
                        </template>
                    </td>
                    <td class="text-center align-middle">{{paper.surveyScore}}</td>
                    <td class="text-center align-middle">{{paper.stateName}}</td>
                    <td class="text-center align-middle">
                        <template v-if="paper.state === surveyPaperState.NON_PUBLISHED">
                            <button class="btn btn-danger btn-sm mr-2" @click="btnDeleteSurveyPaperInfo_Click(paper.surveyPaperId)">删除</button>
                            <button class="btn btn-info btn-sm"
                                    @click="btnUpdateSurveyPaperState_Click(paper.surveyPaperId, surveyPaperState.PUBLISHED,
                                    '确定发布此问卷？问卷发布后，问卷内容将不可更改')">
                                发布
                            </button>
                        </template>
                        <template v-else-if="paper.state === surveyPaperState.PUBLISHED">
                            <button class="btn btn-info btn-sm" @click="btnShowSurveyPaperDetailEdit_Click(paper.surveyPaperId, paper.surveyTemplateId)">
                                反馈管理
                            </button>
                        </template>
                        <template v-else>
                            <button class="btn btn-info btn-sm" @click="btnShowSurveyPaperDetailView_Click(paper.surveyPaperId, paper.surveyTemplateId)">
                                反馈详情
                            </button>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="card-footer text-center" v-if="canEdit">
                <button class="btn btn-primary" @click="btnAddSurveyPaperInfo_Click">创建反馈问卷</button>
            </div>
        </div>


        <b-modal v-model="isAddSurveyPaperInfoDialogOpen"
                 title="添加反馈问卷"
                 ok-title="确定" cancel-title="取消" @ok="addSurveyPaperInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputEvaluateClassName" class="col-sm-3 col-form-label text-right">问卷名称</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputEvaluateClassName" placeholder="问卷名称"
                           v-model="addSurveyPaperInfo.surveyPaperName">
                </div>
            </div>
            <div class="form-group row">
                <label for="inputEvaluateRuleId" class="col-sm-3 col-form-label text-right">问卷模板</label>
                <div class="col-sm-8">
                    <select class="form-control" id="inputEvaluateRuleId" v-model="addSurveyPaperInfo.surveyTemplateId">
                        <option value="">（请选择）</option>
                        <option v-for="tmpl in surveyTemplateData" :key="tmpl.surveyTemplateId" :value="tmpl.surveyTemplateId">{{tmpl.surveyTemplateName}}</option>
                    </select>
                </div>
            </div>
        </b-modal>

        <b-modal v-model="isAddSurveyPaperTeacherCourseInfoDialogOpen"
                 title="添加反馈问卷关联的讲师课程信息"
                 ok-title="确定" cancel-title="取消" @ok="addPaperTeacherCourseInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputTeacherCourse" class="col-sm-3 col-form-label text-right">问卷模板</label>
                <div class="col-sm-8">
                    <select class="form-control" id="inputTeacherCourse" v-model="addSurveyPaperTeacherCourseInfo.courseTeacherId">
                        <option value="">（请选择）</option>
                        <option v-for="data in projectTeacherCourseData" :key="data.courseTeacherId" :value="data.courseTeacherId">
                            {{data.personName}} - {{data.courseName}}
                        </option>
                    </select>
                </div>
            </div>
        </b-modal>

        <b-modal v-model="isSurveyPaperDetailEditDialogOpen"
                 title="反馈问卷信息管理" size="lg"
                 :hide-footer="true" @hidden="getSurveyPaperData"
                 :no-close-on-backdrop="true">
            <survey-paper-detail-edit :survey-paper-id="currentSurveyPaperId" :survey-template-id="currentSurveyTemplateId" :class-id="currentClassId" @close="isSurveyPaperDetailEditDialogOpen=false"></survey-paper-detail-edit>
        </b-modal>
        <b-modal v-model="isSurveyPaperDetailViewDialogOpen"
                 title="反馈问卷信息详情" size="lg"
                 :hide-footer="true"
                 :no-close-on-backdrop="true">
            <survey-paper-detail-view :survey-paper-id="currentSurveyPaperId" :class-id="currentClassId"></survey-paper-detail-view>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";
import projectApi from "@/utils/api/project";
import SurveyPaperDetailEdit from "@/components/study/SurveyPaperDetailEdit";
import SurveyPaperDetailView from "@/components/study/SurveyPaperDetailView";
export default {
    name: "StudySurveyDataManage",
    components: {SurveyPaperDetailView, SurveyPaperDetailEdit},
    props: {
        projectId: {type: String, required: true},
        classId: {type: String, required: true},
        canEdit: {type: Boolean, required: false, default: false}
    },
    data: function () {
        return {
            surveyTemplateType: dictionary.surveyTemplateType,
            surveyPaperState: dictionary.surveyPaperState,

            projectTeacherCourseData: [],
            surveyTemplateData: [],
            surveyPaperData: [],

            addSurveyPaperInfo: {
                classId: this.classId,
                surveyTemplateId: '',
                surveyPaperName: '',
            },
            isAddSurveyPaperInfoDialogOpen: false,

            addSurveyPaperTeacherCourseInfo: {
                surveyPaperId: '',
                courseTeacherId: ''
            },
            isAddSurveyPaperTeacherCourseInfoDialogOpen: false,

            currentSurveyPaperId: '',
            currentSurveyTemplateId: '',
            currentClassId: '',
            isSurveyPaperDetailEditDialogOpen: false,
            isSurveyPaperDetailViewDialogOpen: false,
        };
    },
    mounted() {
        this.getProjectTeacherCourseData();
        this.getSurveyTemplateData();
        this.getSurveyPaperData();
    },
    methods: {
        getSurveyTemplateData() {
            studyApi.survey.template.getSurveyTemplateData().then(res => {
                this.surveyTemplateData = res.data.filter(item => {
                    return item.state === dictionary.surveyTemplateState.V2_PUBLISHED;
                });
            });
        },
        getProjectTeacherCourseData() {
            projectApi.project.teacherCourse.getProjectTeacherCourseData(this.projectId).then(res => {
                this.projectTeacherCourseData = res.data;
            });
        },
        getSurveyPaperData() {
            studyApi.survey.paper.getSurveyPaperData(this.classId).then(res => {
                if (this.canEdit) {
                    this.surveyPaperData = res.data;
                }
                else {
                    this.surveyPaperData = res.data.filter(item => {
                        return item.state === dictionary.surveyPaperState.COMPLETED;
                    });
                }
            });
        },

        btnAddSurveyPaperInfo_Click() {
            this.addSurveyPaperInfo = {
                classId: this.classId,
                surveyTemplateId: '',
                surveyPaperName: '',
            };
            this.isAddSurveyPaperInfoDialogOpen = true;
        },
        addSurveyPaperInfoDialog_OK() {
            studyApi.survey.paper.insertSurveyPaperInfo(this.addSurveyPaperInfo).then(res => {
                this.getSurveyPaperData();
            });
        },

        btnDeleteSurveyPaperInfo_Click(surveyPaperId) {
            if (confirm('确定删除当前反馈问卷？')) {
                studyApi.survey.paper.deleteSurveyPaperInfo(surveyPaperId).then(res => {
                    this.getSurveyPaperData();
                })
            }
        },

        btnUpdateSurveyPaperState_Click(surveyPaperId, state, message) {
            if (confirm(message)) {
                let info = {surveyPaperId, state};
                studyApi.survey.paper.updateSurveyPaperState(info).then(res => {
                    this.getSurveyPaperData();
                });
            }
        },


        btnAddPaperTeacherCourseInfo_Click(surveyPaperId) {
            this.addSurveyPaperTeacherCourseInfo = {
                surveyPaperId: surveyPaperId,
                courseTeacherId: ''
            };
            this.isAddSurveyPaperTeacherCourseInfoDialogOpen = true;
        },
        addPaperTeacherCourseInfoDialog_OK() {
            studyApi.survey.paper.teacherCourse.insertSurveyPaperTeacherCourseInfo(this.addSurveyPaperTeacherCourseInfo).then(res => {
                this.getSurveyPaperData();
            });
        },

        btnDeleteTeacherCourseData_Click(surveyPaperTeacherCourseId) {
            if (confirm('删除此课程？')) {
                studyApi.survey.paper.teacherCourse.deleteSurveyPaperTeacherCourseInfo(surveyPaperTeacherCourseId).then(res => {
                    this.getSurveyPaperData();
                });
            }
        },


        btnShowSurveyPaperDetailEdit_Click(surveyPaperId, surveyTemplateId) {
            this.currentSurveyPaperId = surveyPaperId;
            this.currentSurveyTemplateId = surveyTemplateId;
            this.currentClassId = this.classId;
            this.isSurveyPaperDetailEditDialogOpen = true;
        },
        btnShowSurveyPaperDetailView_Click(surveyPaperId, surveyTemplateId) {
            this.currentSurveyPaperId = surveyPaperId;
            this.currentSurveyTemplateId = surveyTemplateId;
            this.currentClassId = this.classId;
            this.isSurveyPaperDetailViewDialogOpen = true;
        },
    }
}
</script>

<style scoped>

</style>